/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ClientService } from '../../../client.service';
import {
  IdentifierTypeDocument,
  TypeTypeDocument,
  GroupLoyaltyTypeDocument
} from '../../../interfaces/tercero.interface';
import {
  CLIENT_TTL_ES,
  IClient,
  IClientBase,
  IClientUpdate
} from '../../../interfaces/client.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-client-update',
  templateUrl: './client-update.component.html'
})
export class ClientUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  typesDocument = IdentifierTypeDocument;
  typesTypeDocument = TypeTypeDocument;
  typeDocumentGroupLoyalty = GroupLoyaltyTypeDocument;

  constructor(private fb: FormBuilder, private serviceBase: ClientService) {
    super(CLIENT_TTL_ES, serviceBase);
  }

  ngOnInit(): void {
    const item = this.row as IClient;
    this.fg = this.fb.group({
      identifierId: [item.identifierId, [Validators.required]],
      idNumber: [
        item.idNumber,
        [Validators.required, Validators.minLength(8), Validators.maxLength(11)]
      ],
      name: [
        item.name,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      address: [
        item.address,
        [
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      email: [
        item.email,
        [
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      phone: [
        item.phone,
        [Validators.minLength(9), Validators.maxLength(9)]
      ],
      typeId: [item.typeId, []],
      groupLoyaltyId: [item.groupLoyaltyId, []]
    });
  }

  onSubmit() {
    const client = this.parseData();
    this.updateItem$(client);
  }

  private parseData() {
    const client = this.fg.value as IClientBase;
    const { typeId, groupLoyaltyId } = this.fg.value;
    if (client.address == null || client.address === '') delete client.address;
    if (client.email == null || client.email === '') delete client.email;
    if (client.phone == null || client.phone === '') delete client.phone;
    if (typeId == null || typeId === '') delete client.typeId;
    if (groupLoyaltyId == null || groupLoyaltyId === '') delete client.groupLoyaltyId;
    return client;
  }
}
